import { ShieldCheck } from 'lucide-react';
import { Secao } from './secao';
import { ZonaEnvio } from './zona-envio';
import { LaudoPublico } from './laudo-publico';
import { ErroAuditoriaAviso } from './erro-auditoria';
import { CapturaInteresse } from './captura-interesse';
import { useAuditoria } from '../hooks/use-auditoria';

/**
 * A isca da landing: manda um `.docx` de contrato social, recebe o laudo na
 * hora — mesmo motor (`packages/validador`) que audita o produto pago. Única
 * seção que fala com a API sem o contador estar logado (`POST /api/auditoria`,
 * `@Publico()`), por isso o texto de confiança abaixo da zona de envio: quem
 * nunca usou o produto precisa saber, ANTES de soltar o arquivo, que ele não
 * fica gravado em lugar nenhum.
 */
export function AuditoriaGratuita(): JSX.Element {
  const { estado, enviar, reiniciar } = useAuditoria();

  return (
    <Secao
      id="auditoria-gratuita"
      rotulo="Auditoria grátis"
      titulo={
        <>
          Não confia no seu <span className="font-semibold">próprio</span> contrato?
          Audite agora.
        </>
      }
      conduz={
        <>
          Envie o .docx e receba o laudo na hora — as mesmas regras que rodam sobre todo
          contrato gerado pelo produto pago.
        </>
      }
    >
      <div className="mx-auto mt-10 max-w-2xl">
        {estado.fase === 'sucesso' ? (
          <div className="flex flex-col gap-6">
            <LaudoPublico resultado={estado.resultado} onNovaAuditoria={reiniciar} />
            {/* Melhor momento da captura: a pessoa acabou de ver o valor. */}
            <CapturaInteresse origem="auditoria" className="cartao-vidro p-5" />
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <ZonaEnvio desabilitado={estado.fase === 'enviando'} onArquivo={enviar} />
            {estado.fase === 'erro' && (
              <ErroAuditoriaAviso
                mensagem={estado.mensagem}
                retryAfterSegundos={estado.retryAfterSegundos}
              />
            )}
          </div>
        )}

        <p className="text-auth-texto-terciario mt-4 flex items-center justify-center gap-1.5 text-xs">
          <ShieldCheck size={14} aria-hidden />O arquivo roda em memória e é descartado ao
          fim da auditoria. Nunca é gravado.
        </p>
      </div>
    </Secao>
  );
}
